export interface ITripParams {
  id: string;
  name: string;
  plantId: string;
}

export interface ITripDetailParams {
  routeId: string;
  tripId: string;
  indexNum: number;
}

export interface ITripCheckIndexNum {
  tripId: string;
  indexNum: number;
}

export interface IGetListTrip {
  plantId?: string;
}

export const TRIP_VARIABLE = {
  getListTrip: (params: IGetListTrip) => {
    return {
      input: {
        ...(params.plantId && { plantId: { equals: params.plantId } }),
      },
    };
  },
  createTripByPlantId: (params: ITripParams) => {
    const { id, name, plantId } = params;

    return {
      input: {
        id: id,
        name: name,
        plantId: plantId,
      },
    };
  },
  checkExistedIndexNum: (params: ITripCheckIndexNum) => {
    const { tripId, indexNum } = params;

    return {
      input: {
        tripId: {
          equals: tripId,
        },
        indexNum: {
          equals: indexNum,
        },
      },
    };
  },
  checkExistedTrip: (routeId: string) => {
    return {
      input: {
        routeId: { equals: routeId },
      },
    };
  },
  createTripDetail: (params: ITripDetailParams) => {
    const { routeId, tripId, indexNum } = params;

    return {
      input: {
        routeId: routeId,
        tripId: tripId,
        indexNum: indexNum,
      },
    };
  },
};
